import { useForm } from 'react-hook-form';
import { ArticleFormValues } from '../settings-modal/types';
import { Article } from '../types';

export function useArticleForm(article?: Article) {
  const methods = useForm<ArticleFormValues>({
    shouldUnregister: false,
    defaultValues: {
      description: article?.description ?? '',
      contributors:
        article?.coCreators?.map((creator) => ({
          value: creator.username,
          label:
            creator.firstName && creator.lastName
              ? `${creator.firstName} ${creator.lastName}`
              : creator.username,
        })) ?? [],
      categories: article?.categories ?? [],
      tags: article?.tags.map((tag) => ({ label: tag, value: tag })) ?? [],
      copyright: article?.copyright ?? '',
      disabledComment:
        article && typeof article.commentable === 'boolean'
          ? !article.commentable
          : false,
    },
  });

  return methods;
}
